// apps/academy/src/components/AcademyLayout.tsx
import { FeedbackSource } from '@neuroforge/shared'
import {
  FeedbackWidget,
  useAuthStore,
  UserMenu,
  redirectToHubLogin,
} from '@neuroforge/shared/client'
import { AppShell, Button, ThemeToggle } from '@neuroforge/ui'
import { Outlet, useLocation } from 'react-router'

import AcademySidebar from './AcademySidebar'

export default function AcademyLayout() {
  const { isAuthenticated } = useAuthStore()
  const { pathname } = useLocation()

  return (
    <AppShell
      ambientVariant="academy"
      routeKey={pathname}
      sidebar={<AcademySidebar />}
      headerActions={
        <>
          {/* AppSwitcher déplacé en haut de AcademySidebar */}
          <ThemeToggle className="h-10 rounded-2xl px-4 text-sm font-semibold transition" />
          {isAuthenticated ? (
            <UserMenu />
          ) : (
            <Button
              variant="secondary"
              size="sm"
              onClick={() => redirectToHubLogin()}
              className="glass"
            >
              Se connecter
            </Button>
          )}
        </>
      }
      overlays={<FeedbackWidget source={FeedbackSource.ACADEMY} />}
    >
      <Outlet />
    </AppShell>
  )
}
